export const QUESTIONS_PREVIEW_PICTURE = process.env.PUBLIC_URL + '/assets/images/video-instruction-preview.png';
export const QUESTIONS_VIDEO = 'https://rutube.ru/play/embed/d16ffcd6a2b1c9621b0bd8654e7ba5aa?p=hEZcvgNx9UWmfGiSlCO3hw';

export const QUESTIONS_SECTIONS_TITLE = {
  VIDEO: 'Видео-инструкция',
  QUESTIONS_ANSWERS: 'Вопросы и ответы',
  TRANSPORTATION_RULES: 'Правила перевозок'
};
